import { priceFormat } from 'components/Shared/Price';

const unitMap: { [key: string]: (value: number) => string } = {
  price: (value: number) => priceFormat({ price: value }),
  default: (value: number) => value.toString()
};

export const unitFormatMap = (name: string) =>
  unitMap[Object.keys(unitMap).find(key => name.includes(key)) || 'default'];
